const doc = [({"en":({"constantBookingPayType":({"credit_card":"credit card", "on_site":"on-site"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;